import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {URLS} from '../../environments/environment';
import {catchError, map, timeout} from 'rxjs/operators';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CarsService {

  carSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  carImportType: BehaviorSubject<any> = new BehaviorSubject(null);
  carResponseSubject: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(private http: HttpClient, private router: Router) {
  }

  filter(params: any) {
    return this.http.post(URLS.API + 'cars/filter', params, {withCredentials: true}).pipe(
      map((res: any) => {
          return res.data;
        }
      ));
  }

  filterPaged(params: any): Observable<any> {
    return this.http.post(URLS.API + 'cars/filterPaged', params, {withCredentials: true})
      .pipe(
        timeout(30000), // 30 seconds timeout
        map((res: any) => res.data),
        catchError(error => {
          if (error.name === 'TimeoutError') {
            this.router.navigate(['/auth/login']);
          }
          return throwError(error);
        })
      );
  }

  filterPagedSeller(params: any): Observable<any> {
    return this.http.post(URLS.API + 'cars/filterPagedSeller', params, {withCredentials: true})
      .pipe(
        timeout(30000), // 30 seconds timeout
        map((res: any) => res.data),
        catchError(error => {
          if (error.name === 'TimeoutError') {
            this.router.navigate(['/auth/login']);
          }
          return throwError(error);
        })
      );
  }

  filterPagedUAE(params: any): Observable<any> {
    return this.http.post(URLS.API + 'cars/filterPagedGA', params, {withCredentials: true})
      .pipe(
        timeout(30000), // 30 seconds timeout
        map((res: any) => res.data),
        catchError(error => {
          if (error.name === 'TimeoutError') {
            this.router.navigate(['/auth/login']);
          }
          return throwError(error);
        })
      );
  }

  filterPagedDamagedUAE(params: any): Observable<any> {
    return this.http.post(URLS.API + 'cars/filterSalvagedPagedGA', params, {withCredentials: true})
      .pipe(
        timeout(30000), // 30 seconds timeout
        map((res: any) => res.data),
        catchError(error => {
          if (error.name === 'TimeoutError') {
            this.router.navigate(['/auth/login']);
          }
          return throwError(error);
        })
      );
  }

  // filterPaged(params: any) {
  //   return this.http.post(URLS.API + 'cars/filterPaged', params, {withCredentials: true}).pipe(
  //     map((res: any) => {
  //         return res.data;
  //       }
  //     ));
  // }

  filterPagedColl(params: any) {
    return this.http.post(URLS.API + 'cars/filterPagedColl', params, { withCredentials: true }).pipe(
      timeout(30000), // 30 seconds timeout
      map((res: any) => res.data),
      catchError(error => {
        if (error.name === 'TimeoutError') {
          this.router.navigate(['/auth/login']);
        }
        return throwError(error);
      })
    );
  }

  // filterPagedColl(params: any) {
  //   return this.http.post(URLS.API + 'cars/filterPagedColl', params, {withCredentials: true}).pipe(
  //     map((res: any) => {
  //         return res.data;
  //       }
  //     ));
  // }

  filterStellantis(params: any) {
    return this.http.post(URLS.API + 'cars/filterStellantis', params, {withCredentials: true}).pipe(
      map((res: any) => {
          return res.data;
        }
      ));
  }

  filterPagedPersonal(params: any) {
    return this.http.post(URLS.API + 'cars/filterPagedPersonal', params, { withCredentials: true }).pipe(
      timeout(30000), // 30 seconds timeout
      map((res: any) => res.data),
      catchError(error => {
        if (error.name === 'TimeoutError') {
          this.router.navigate(['/auth/login']);
        }
        return throwError(error);
      })
    );
  }

  // filterPagedPersonal(params: any) {
  //   return this.http.post(URLS.API + 'cars/filterPagedPersonal', params, {withCredentials: true}).pipe(
  //     map((res: any) => {
  //         return res.data;
  //       }
  //     ));
  // }

  vinCheck(params: any) {
    return this.http.post(URLS.API + 'cars/vinCheck', params, {withCredentials: true}).pipe(
      map((res: any) => {
          return res.data;
        }
      ));
  }

  getCarById(id: any, customerType: any = 'commercial') {
    return this.http.get(URLS.API + 'cars/' + id + '/' + customerType, {withCredentials: true}).pipe(
      map((res: any) => {
          return res.data;
        }
      ));
  }

  getCarByIdNew(id: any, customerType: any = 'commercial') {
    return this.http.get(URLS.API + 'cars/ById?id=' + id, {withCredentials: true}).pipe(
      map((res: any) => {
          return res.data;
        }
      ));
  }
  getCarStellantisById(id: any, customerType: any = 'commercial') {
    return this.http.get(URLS.API + 'cars/stellantis/' + id + '/' + customerType, {withCredentials: true}).pipe(
      map((res: any) => {
          return res.data;
        }
      ));
  }

    filterInterested(params: any) {
        return this.http.post(URLS.API + 'cars/filterInterested', params, {withCredentials: true}).pipe(
            map((res: any) => {
                    return res.data;
                }
            ));
    }

    filterLiked(params: any) {
        return this.http.post(URLS.API + 'cars/filterLiked', params, {withCredentials: true}).pipe(
            map((res: any) => {
                    return res.data;
                }
            ));
    }


  getFilterMeta() {
    return this.http.get(URLS.API + 'cars/filterMeta', { withCredentials: true }).pipe(
      timeout(30000), // 30 seconds timeout
      map((res: any) => res.data),
      catchError(error => {
        if (error.name === 'TimeoutError') {
          this.router.navigate(['/auth/login']);
        }
        return throwError(error);
      })
    );
  }

  getFilterMetaSalvaged() {
    return this.http.get(URLS.API + 'cars/filterMetaSalvaged', { withCredentials: true }).pipe(
      timeout(30000), // 30 seconds timeout
      map((res: any) => res.data),
      catchError(error => {
        if (error.name === 'TimeoutError') {
          this.router.navigate(['/auth/login']);
        }
        return throwError(error);
      })
    );
  }

  getFilterMetaColl() {
    return this.http.get(URLS.API + 'cars/filterMetaColl', { withCredentials: true }).pipe(
      timeout(30000), // 30 seconds timeout
      map((res: any) => res.data),
      catchError(error => {
        if (error.name === 'TimeoutError') {
          this.router.navigate(['/auth/login']);
        }
        return throwError(error);
      })
    );
  }

  getFilterMetaSeller(userId: any, pageId: any = 'all') {
    return this.http.get(URLS.API + `cars/filterMetaSeller?userId=${userId}&pageId=${pageId}`, { withCredentials: true }).pipe(
      timeout(30000), // 30 seconds timeout
      map((res: any) => res.data),
      catchError(error => {
        if (error.name === 'TimeoutError') {
          this.router.navigate(['/auth/login']);
        }
        return throwError(error);
      })
    );
  }

  getFilterMetaUAE(userId: any, pageId: any = 'all') {
    return this.http.get(URLS.API + `cars/filterMetaGA?userId=${userId}&pageId=${pageId}`, { withCredentials: true }).pipe(
      timeout(30000), // 30 seconds timeout
      map((res: any) => res.data),
      catchError(error => {
        if (error.name === 'TimeoutError') {
          this.router.navigate(['/auth/login']);
        }
        return throwError(error);
      })
    );
  }

  getFilterMetaPersonal() {
    return this.http.get(URLS.API + 'cars/filterMetaPersonal', { withCredentials: true }).pipe(
      timeout(30000), // 30 seconds timeout
      map((res: any) => res.data),
      catchError(error => {
        if (error.name === 'TimeoutError') {
          this.router.navigate(['/auth/login']);
        }
        return throwError(error);
      })
    );
  }

  // getFilterMeta() {
  //   return this.http.get(URLS.API + 'cars/filterMeta', {withCredentials: true}).pipe(
  //     map((res: any) => {
  //         return res.data;
  //       }
  //     ));
  // }
  //
  // getFilterMetaColl() {
  //   return this.http.get(URLS.API + 'cars/filterMetaColl', {withCredentials: true}).pipe(
  //     map((res: any) => {
  //         return res.data;
  //       }
  //     ));
  // }
  //
  // getFilterMetaPersonal() {
  //   return this.http.get(URLS.API + 'cars/filterMetaPersonal', {withCredentials: true}).pipe(
  //     map((res: any) => {
  //         return res.data;
  //       }
  //     ));
  // }

  getCars() {
    return this.http.get(URLS.API + 'cars', {withCredentials: true}).pipe(
      map((res: any) => {
        return res.data;
      }
    ));
  }

  getMyList() {
    return this.http.get(URLS.API + 'cars/myList', {withCredentials: true}).pipe(
      map((res: any) => {
          return res.data;
        }
      ));
  }

  updateCarInMyList(carId: any, isFixed: any, value: any, disclaimer: any, importer: any, notes: any,
                    calculatedValueForCustomer: any, customer: any,
                    source: any, selection: any,
                    serializedTaxList: any) {
    return this.http.post(URLS.API + 'cars/updateCarInMyList',
      {carId, isFixed, value, disclaimer, importer, notes,
          calculatedValueForCustomer, customer,
          source, selection, serializedTaxList },
      {withCredentials: true}).pipe(
      map((res: any) => {
          return res;
        }
      ));
  }

  updateInterest(carId: any, interest: any, importType: any) {
    return this.http.post(URLS.API + 'cars/updateInterest', {carId, interest, importType },
      {withCredentials: true}).pipe(
      map((res: any) => {
          return res;
        }
      ));
  }

  updateNewInterest(carId: any, userData: any, importType: any) {
    return this.http.post(URLS.API + 'cars/updateInterestNew', {carId, userData, importType },
      {withCredentials: true}).pipe(
      map((res: any) => {
          return res;
        }
      ));
  }

  updateUAEInterest(carId: any, userData: any, importType: any) {
    return this.http.post(URLS.API + 'cars/updateInterestUAE', {carId, userData, importType },
      {withCredentials: true}).pipe(
      map((res: any) => {
          return res;
        }
      ));
  }

  removeFromList(myCarId: any) {
    return this.http.post(URLS.API + 'cars/removeFromList', {myCarId },
      {withCredentials: true}).pipe(
      map((res: any) => {
          return res;
        }
      ));
  }

  setAdminStatus(myCarId: any, status: string) {
    return this.http.post(URLS.API + 'adminapi/cars/setAdminStatus', {id: myCarId, status },
      {withCredentials: true}).pipe(
      map((res: any) => {
          return res;
        }
      ));
  }

  addToMyList(carId: any) {
    return this.http.post(URLS.API + 'cars/addToMyList', {carId },
      {withCredentials: true}).pipe(
      map((res: any) => {
          return res;
        }
      ));
  }

  exportCarToPdf(car: any) {
    console.log(car);
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.http.get(URLS.APIPDF + 'cars/pdf', {params: {id: car.myCarId}, headers, responseType: 'blob', withCredentials: true});
  }

}
